<template>
    <label class="radioSet h-100" v-bind:class="{'is-selected' : isSelected}">
        <div class="radioSet__body">
            <div class="radioSet__left">
                <div class="radioSet__header">
                    <div class="radioSet__title">{{ productSetTypeName }}</div>
                    <div class="radioSet__subtitle">{{ setName }}</div>
                    <div class="radioSet__price">
                        <div class="priceAction">
                            <div class="priceAction__after">{{$nf(discountPriceWithVatRounded, 'priceWithoutCurrency')}} {{currency}}</div>
                            <div class="priceAction__before" v-if="discountPriceWithVatRounded != priceWithVatRounded">{{$nf(priceWithVatRounded, 'priceWithoutCurrency')}} {{currency}}</div>
                        </div>
                    </div>
                </div>
                <div class="radioSet__items setItems">
                    <SetRadioItemProduct :key="product.id" :product="product" v-for="product in products"></SetRadioItemProduct>
                </div>
            </div>
            <div class="radioSet__image" v-if="bedImage != null">
                <img :src="bedImage" alt="{{ name }}"/>
            </div>
        </div>
    </label>
</template>

<script>
    export default {
        props: ["set"],
        computed: {
            discountPriceWithVatRounded: function () {
                var price = this.priceWithVat.price * (100 - this.set.discount.discount) / 100;
                return price;
            },
            priceWithVatRounded: function() {
                return this.priceWithVat.price;
            },
            priceWithVat: function () {
                return {
                    price: this.set.price.priceWithVat,
                    currency: this.set.price.currency
                };
            },
            currency: function () {
                return this.priceWithVat.currency.htmlString;
            },
            isSelected: function () {
                return this.$store.getters.isSelectedThisSet(this.set.id);
            },
            products: function () {
                return this.set.products.filter(function(item) { return item.required;});
            },
            bedImage: function () {
                if (this.set.productSetType == null) {
                    return null;
                }
                switch (this.set.productSetType.identifier) {
                    case 'bed-double':
                        return '/images/svg/bed-double.svg';
                    case 'bed-double-split':
                        return '/images/svg/bed-double-split.svg';
                    case 'bed-single':
                        return '/images/svg/bed-single.svg';
                    case 'bed-children':
                        return '/images/svg/bed-children.svg';
                    default:
                        return null;
                }
            },
            productSetTypeName: function () {
                return this.set.productSetType.name;
            },
            setName: function () {
                return this.set.name;
            }
        }
    };
</script>
